import {MMQueryOptions} from 'lionheartland';


export class SODeleteToken {

  constructor(
    public uid: string,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
}
